module.exports = __webpack_public_path__ + "static/img/testimonial.e5bfa6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fullwidth/testimonial.png
// module id = BAr8
// module chunks = 1